module.exports = __webpack_public_path__ + "static/media/6COPUOS3.a19c04ba.jpg";